<script>
    let audio = null;
    export let play;
    play = () => {
        if (audio !== null) {
            audio.volume = 0.1;
            try {
                const fakePromise = { catch: () => null };
                const maybePromise = (audio.play() || fakePromise).catch(() => null);
            } catch (e) {
            }
        }
    };
    export let pause;
    pause = () => {
        if (audio !== null) {
            audio.volume = 0.1;
            audio.pause();
        }
    };
</script>

<style>
    audio {
        display: none;
    }
</style>

<!-- svelte-ignore a11y-media-has-caption -->
<audio loop bind:this={audio}>
    <source src="music.mp3" type="audio/mpeg">
</audio>